<ng-content></ng-content>
@if (shouldDisplayError) {
    <div class="pl-1 pr-1 validation-text">
        @for (formControlErrorKey of formControlErrorKeys; track formControlErrorKey) {
            <small> {{ getValidationMessage(formControlErrorKey) }}<br></small>
        }
    </div>
}